// libraries
import React from 'react'

export function UxAngleUp() {
    return (
        <svg width="24" height="14" viewBox="0 0 24 14" xmlns="http://www.w3.org/2000/svg"><path d="M22 13.3C21.7 13.3 21.4 13.2 21.1 12.9L12 3.79998L2.9 12.9C2.4 13.4 1.6 13.4 1.1 12.9C0.599998 12.4 0.599998 11.6 1.1 11.1L11.1 1.09998C11.6 0.599976 12.4 0.599976 12.9 1.09998L22.9 11.1C23.4 11.6 23.4 12.4 22.9 12.9C22.7 13.1 22.4 13.3 22 13.3Z"/></svg>
    )
}

export function UxAngleDown() {
    return (
        <svg width="24" height="14" viewBox="0 0 24 14" xmlns="http://www.w3.org/2000/svg"><path d="M12 13.3C11.7 13.3 11.4 13.2 11.1 12.9L1.1 2.89998C0.6 2.39998 0.6 1.59998 1.1 1.09998C1.6 0.599976 2.4 0.599976 2.9 1.09998L12 10.2L21.1 1.09998C21.6 0.599976 22.4 0.599976 22.9 1.09998C23.4 1.59998 23.4 2.39998 22.9 2.89998L12.9 12.9C12.7 13.2 12.3 13.3 12 13.3Z"/></svg>
    )
}

export function UxAngleLeft() {
    return (
        <svg width="14" height="24" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 23.3C11.7 23.3 11.4 23.2 11.1 22.9L1.1 12.9C0.599998 12.4 0.599998 11.6 1.1 11.1L11.1 1.09998C11.6 0.599976 12.4 0.599976 12.9 1.09998C13.4 1.59998 13.4 2.39998 12.9 2.89998L3.8 12L12.9 21.1C13.4 21.6 13.4 22.4 12.9 22.9C12.7 23.2 12.3 23.3 12 23.3Z"/></svg>
    )
}

export function UxAngleRight() {
    return (
        <svg width="14" height="24" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg"><path d="M2 23.3C1.7 23.3 1.4 23.2 1.1 22.9C0.6 22.4 0.6 21.6 1.1 21.1L10.2 12L1.1 2.89998C0.6 2.39998 0.6 1.59998 1.1 1.09998C1.6 0.599976 2.4 0.599976 2.9 1.09998L12.9 11.1C13.4 11.6 13.4 12.4 12.9 12.9L2.9 22.9C2.6 23.2 2.3 23.3 2 23.3Z"/></svg>
    )
}